import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import Sidebar from "../shared/Sidebar";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { Link, useLocation } from "react-router-dom";
import "./forum_Project.css";
import Modal from "react-modal";
import { Button } from "../../ui/button";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Forum_Project = () => {
  // Cascading selections for Budget dropdowns
  const [selectedSectionId, setSelectedSectionId] = React.useState("");
  const [selectedGroupementId, setSelectedGroupementId] = React.useState("");
  const [selectedCategorieId, setSelectedCategorieId] = React.useState("");
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const [isDropdownOpen1, setIsDropdownOpen1] = useState(false);
  const [isDropdownOpen2, setIsDropdownOpen2] = useState(false);
  const [isDropdownOpen3, setIsDropdownOpne3] = useState(false);
  const [isDropdownOpen4, setIsDropdownOpne4] = useState(false);
  const [isDropdownOpen5, setIsDropdownOpne5] = useState(false);
  const [isDropdownOpen6, setIsDropdownOpen6] = useState(false);
  const [isDropdownOpen7, setIsDropdownOpen7] = useState(false);
  const [areDropdownsVisible, setAreDropdownsVisible] = useState(false); // Control dropdown visibility

  // State to store user information
  const [userInfo, setUserInformation] = useState("");

  const [isFormVisible, setIsFormVisible] = useState(false);
  const [newTeamName, setNewTeamName] = useState("");

  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [teams, setTeams] = useState([]); // Initialize as an empty array
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [resumeFr, setResumeFr] = useState("");
  const [resumeEn, setResumeEn] = useState("");
  const [taskFormVisible, setTaskFormVisible] = useState({});
  const [tasks, setTasks] = useState({});
  const [taskName, setTaskName] = useState("");
  const [taskDescription, setTaskDescription] = useState("");
  const [members, setMembers] = useState([]);
  const [newMember, setNewMember] = useState([]);
  const [taskMember, setTaskMember] = useState("");
  const [taskStartDate, setTaskStartDate] = useState("");
  const [taskEndDate, setTaskEndDate] = useState("");

  const [intro, setIntro] = useState("");
  const [objectives, setObjectives] = useState("");
  const [methodology, setMethodology] = useState("");
  const [results, setResults] = useState("");
  const [ethics, setEthics] = useState("");
  const [competitionId, setCompetitionId] = useState("");
  const [competitionData, setCompetitionData] = useState(null);

  const [isFormVisiblePlaning, setIsFormVisiblePlaning] = useState(false);
  const [activity, setActivity] = useState("");
  const [description, setDescription] = useState("");
  const [team, setTeam] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [totalDays, setTotalDays] = useState("");
  const [planings, setPlanings] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [selectedDomain, setSelectedDomain] = useState("");
  const [currentTeamIndex, setCurrentTeamIndex] = useState(null);
  const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format

  const [formData, setFormData] = useState({
    projectTitle: "",
    startDate: today, // Default to today's date
    endDate: today, // Default to today's date
    applicationField: "",
    domain: "",
    subDomain: "",
    totalAmount: "",
    requestedAmount: "",
  });
  const [data, setData] = useState([]); // Store dropdown data
  const [filteredGroupements, setFilteredGroupements] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [filteredSections, setFilteredSections] = useState([]);
  // const [idcompetition, setIdCompetition] = useState(null);
  const [memberRole, setMemberRole] = useState("");
  const [memberTitle, setMemberTitle] = useState("");
  const [memberEmail, setMemberEmail] = useState("");
  const [speciality, setSpeciality] = useState("");
  const [structure, setStructure] = useState("");
  const [contribution, setContribution] = useState("");
  const [workingTime, setWorkingTime] = useState("");
  const [selectedTeamId, setSelectedTeamId] = useState(null);

  const [savedBudgets, setSavedBudgets] = useState([]); // Store multiple saved budgets// To store the saved data
  const [showForm, setShowForm] = useState(false);
  const [showSoumettre, setShowSoumettre] = useState(false);
  const [showCreerDemande, setShowCreerDemande] = useState(true);
  // Add missing states
  const [submitted, setSubmitted] = useState(false); // track if project submitted
  const [hideCreateButtonClicked, setHideCreateButtonClicked] = useState(false); // track button state

  // Budget inline edit state
  const [editingBudgetIndex, setEditingBudgetIndex] = useState(null);
  const [editDescription, setEditDescription] = useState("");
  const [editAmount, setEditAmount] = useState("");
  const [editSectionId, setEditSectionId] = useState("");
  const [editGroupementId, setEditGroupementId] = useState("");
  const [editCategorieId, setEditCategorieId] = useState("");

  // Location & params
  const location = useLocation();
  const {
    idcompetition,
    budgetParametreId,
    projectId,
    hideCreateButton,
    date_fin,
    fromMyProject,
  } = location.state || {};
  // BEFORE:
  // const canEdit = !(submitted && fromMyProject);
  // const ro = !canEdit;
  // AFTER: submitted alone controls edit lock
  const canEdit = !submitted;
  const ro = submitted;
  const showSave = !submitted; // helper to hide all Enregistrer buttons

  useEffect(() => {
    const stored = localStorage.getItem(
      `hideCreateButtonClicked_${projectId || "new"}`
    );
    setHideCreateButtonClicked(stored === "true");
  }, [projectId]);

  const [isAddingNewTeam, setIsAddingNewTeam] = useState(false); // Tracks if adding a new team

  const notifySuccess = (message) => toast.success(message);
  const notifyError = (message) => toast.error(message);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/fetch_dropdown_data.php`)
      .then((response) => response.json())
      .then((fetchedData) => {
        console.log("Fetched Data:", fetchedData); // Check fetched data
        setData(fetchedData); // Store data in state
      })
      .catch((error) => console.error("Error fetching dropdown data:", error));
  }, []);

  const filterDataByBudgetParametre = (budgetParametreId, data) => {
    if (!budgetParametreId) {
      console.warn("No budgetParametreId provided!");
      return;
    }

    console.log("Filtering with budgetParametreId:", budgetParametreId);

    // Filter data based on the budgetParametreId
    const filteredData = data.filter(
      (item) =>
        parseInt(item.budget_parametre_id) === parseInt(budgetParametreId)
    );

    if (filteredData.length === 0) {
      console.warn(
        "No data found for the given budgetParametreId:",
        budgetParametreId
      );
    }

    // Initialize unique collections for sections, groupements, and categories
    const uniqueSections = [];
    const uniqueGroupements = [];
    const uniqueCategories = [];

    const sectionMap = new Map();
    const groupementMap = new Map();

    filteredData.forEach((item) => {
      // Check and add unique sections
      if (!sectionMap.has(item.section_id)) {
        sectionMap.set(item.section_id, {
          section_id: item.section_id,
          section_appellation: item.section_appellation,
        });
        uniqueSections.push(sectionMap.get(item.section_id));
      }

      // Check and add unique groupements under each section
      if (!groupementMap.has(item.groupement_id)) {
        groupementMap.set(item.groupement_id, {
          groupement_id: item.groupement_id,
          groupement_appellation: item.groupement_appellation,
          groupement_section_id: item.groupement_section_id,
        });
        uniqueGroupements.push(groupementMap.get(item.groupement_id));
      }

      // Add all unique categories
      uniqueCategories.push({
        categorie_id: item.categorie_id,
        categorie_appellation: item.categorie_appellation,
        categorie_groupement_id: item.categorie_groupement_id,
      });
    });

    // Set filtered results to state
    setFilteredSections(uniqueSections);
    setFilteredGroupements(uniqueGroupements);
    setFilteredCategories(uniqueCategories);

    console.log("Filtered Sections:", uniqueSections);
    console.log("Filtered Groupements:", uniqueGroupements);
    console.log("Filtered Categories:", uniqueCategories);
  };

  useEffect(() => {
    if (budgetParametreId && data.length > 0) {
      filterDataByBudgetParametre(budgetParametreId, data);
    } else if (!budgetParametreId) {
      console.error("Missing budgetParametreId. Filtering cannot proceed.");
    }
  }, [budgetParametreId, data]);

  const SaveDataBudget = () => {
    // Extract values from the dropdowns and inputs
    const sectionElement = document.querySelector("select[name='section']");
    const groupementElement = document.querySelector(
      "select[name='groupement']"
    );
    const categorieElement = document.querySelector("select[name='categorie']");
    const descriptionElement = document.querySelector(
      "input[name='description']"
    );
    const budgetAmountElement = document.querySelector(
      "input[name='budgetAmount']"
    );

    // Debugging logs to check if elements are found
    console.log("Section Element:", sectionElement);
    console.log("Groupement Element:", groupementElement);
    console.log("Categorie Element:", categorieElement);
    console.log("Description Element:", descriptionElement);
    console.log("Budget Amount Element:", budgetAmountElement);

    // Ensure all elements are found
    if (
      !sectionElement ||
      !groupementElement ||
      !categorieElement ||
      !descriptionElement ||
      !budgetAmountElement
    ) {
      notifyError("Veuillez vous assurer que tous les champs sont visibles et remplis.");
      return;
    }

    const sectionId = sectionElement.value;
    const groupementId = groupementElement.value;
    const categorieId = categorieElement.value;
    const description = descriptionElement.value;
    const budgetAmount = budgetAmountElement.value;

    // Debugging logs to check field values
    console.log("Section ID:", sectionId);
    console.log("Groupement ID:", groupementId);
    console.log("Categorie ID:", categorieId);
    console.log("Description:", description);
    console.log("Budget Amount:", budgetAmount);

    // Get budgetParametreId and projectId from location.state
    const { budgetParametreId, projectId } = location.state || {};

    // Ensure all fields are filled, including budgetParametreId and projectId
    if (
      !sectionId ||
      !groupementId ||
      !categorieId ||
      !description ||
      !budgetAmount ||
      !budgetParametreId ||
      !projectId
    ) {
      notifyError("Veuillez remplir tous les champs !");
      return;
    }

    // Construct the data to send to the backend
    const budgetData = {
      section_id: sectionId,
      groupement_id: groupementId,
      categorie_id: categorieId,
      description: description,
      budget_amount: budgetAmount,
      budget_parametre_id: budgetParametreId,
      project_id: projectId,
    };
    console.log("Budget Data Sent:", budgetData);

    // Send the data to the backend
    fetch(`${process.env.REACT_APP_BASE_URL}/saveBudget.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(budgetData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message) {
          notifySuccess(data.message);
        }

        if (data.data) {
          const sectionName = filteredSections.find(
            (section) =>
              section.section_id.toString() ===
              data.data.ID_ligne_budget_section.toString()
          )?.section_appellation;

          const groupementName = filteredGroupements.find(
            (groupement) =>
              groupement.groupement_id.toString() ===
              data.data.ID_ligne_budget_groupement.toString()
          )?.groupement_appellation;

          const categorieName = filteredCategories.find(
            (categorie) =>
              categorie.categorie_id.toString() ===
              data.data.ID_ligne_budget_categorie.toString()
          )?.categorie_appellation;

          const newBudget = {
            ...data.data,
            section_name: sectionName || "N/A",
            groupement_name: groupementName || "N/A",
            categorie_name: categorieName || "N/A",
          };

          setSavedBudgets((prevBudgets) => [...prevBudgets, newBudget]);

          // Reset dropdowns and inputs to default values
          sectionElement.value = "";
          groupementElement.value = "";
          categorieElement.value = "";
          descriptionElement.value = "";
          budgetAmountElement.value = "";
        }
      })
      .catch((error) => {
        console.error("Error saving budget:", error);
        notifyError("Échec de l'enregistrement du budget. Veuillez réessayer.");
      });
  };

  // Budget table row edit handlers
  const handleEditBudget = (index) => {
    const b = savedBudgets[index];
    setEditingBudgetIndex(index);
    setEditDescription(b.valeur_description || "");
    setEditAmount(b.valeur_montant || "");
    setEditSectionId(
      b.ID_ligne_budget_section?.toString() ||
        b.section_id?.toString() ||
        ""
    );
    setEditGroupementId(
      b.ID_ligne_budget_groupement?.toString() ||
        b.groupement_id?.toString() ||
        ""
    );
    setEditCategorieId(
      b.ID_ligne_budget_categorie?.toString() ||
        b.categorie_id?.toString() ||
        ""
    );
  };

  const handleCancelBudgetEdit = () => {
    setEditingBudgetIndex(null);
    setEditDescription("");
    setEditAmount("");
    setEditSectionId("");
    setEditGroupementId("");
    setEditCategorieId("");
  };

  const handleSaveBudgetEdit = async () => {
    if (editingBudgetIndex === null) return;
    if (!editSectionId || !editGroupementId || !editCategorieId) {
      notifyError("Veuillez sélectionner la section, le groupement et la catégorie.");
      return;
    }

    const updated = [...savedBudgets];
    const previous = [...savedBudgets];
    const target = { ...updated[editingBudgetIndex] };
    target.valeur_description = editDescription;
    target.valeur_montant = editAmount;
    target.ID_ligne_budget_section = parseInt(editSectionId, 10);
    target.ID_ligne_budget_groupement = parseInt(editGroupementId, 10);
    target.ID_ligne_budget_categorie = parseInt(editCategorieId, 10);

    const sectionName =
      filteredSections.find(
        (s) => s.section_id?.toString() === editSectionId
      )?.section_appellation || "";
    const groupementName =
      filteredGroupements.find(
        (g) => g.groupement_id?.toString() === editGroupementId
      )?.groupement_appellation || "";
    const categorieName =
      filteredCategories.find(
        (c) => c.categorie_id?.toString() === editCategorieId
      )?.categorie_appellation || "";

    target.section_name = sectionName;
    target.groupement_name = groupementName;
    target.categorie_name = categorieName;

    updated[editingBudgetIndex] = target;
    setSavedBudgets(updated);

    try {
      const resp = await fetch(`${process.env.REACT_APP_BASE_URL}/modify_budget.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id_budget_projet: target.id_budget_projet,
          section_id: parseInt(editSectionId, 10),
          groupement_id: parseInt(editGroupementId, 10),
          categorie_id: parseInt(editCategorieId, 10),
          valeur_description: editDescription,
          valeur_montant: editAmount,
        }),
      });
      const json = await resp.json().catch(() => null);
      if (json && json.success && json.data) {
        // Replace row with authoritative backend version
        updated[editingBudgetIndex] = json.data;
        setSavedBudgets(updated);
        notifySuccess("Budget modifié avec succès.");
        await fetchBudgetData();
      } else {
        notifyError(json?.message || "La mise à jour du budget a échoué.");
        setSavedBudgets(previous);
      }
    } catch (e) {
      console.warn("modify_budget.php update failed (local state retained)", e);
      notifyError("Erreur réseau lors de la modification du budget.");
      setSavedBudgets(previous);
    }
    handleCancelBudgetEdit();
  };

  const handleDeleteBudget = async (index) => {
    const target = savedBudgets[index];
    if (!target) return;
    const previous = [...savedBudgets];
    setSavedBudgets((prev) => prev.filter((_, i) => i !== index));
    if (editingBudgetIndex === index) handleCancelBudgetEdit();
    try {
      const resp = await fetch(`${process.env.REACT_APP_BASE_URL}/deleteBudget.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id_budget_projet: target.id_budget_projet }),
      });
      const json = await resp.json().catch(() => null);
      if (json && json.success) {
        notifySuccess("Ligne de budget supprimée.");
        await fetchBudgetData();
      } else {
        notifyError(json?.message || "La suppression a échoué.");
        setSavedBudgets(previous);
      }
    } catch (e) {
      console.warn("Delete budget line failed (reverting UI)", e);
      notifyError("Erreur réseau lors de la suppression.");
      setSavedBudgets(previous);
    }
  };

  // Log to check if competition ID is correctly retrieved
  useEffect(() => {
    if (idcompetition) {
      console.log("Competition ID:", idcompetition);
    }
  }, [idcompetition]);

  const biologyOptions = [
    "Fonctionnement normal",
    "Déclenchement du cancer : aberrations chromosomiques",
    "Déclenchement du cancer : oncogènes et gènes suppresseurs de tumeurs",
    "Évolution du cancer et métastase",
    "Ressources et infrastructures",
    "Biologie du cancer",
  ];
  const etiologieOptions = [
    "Facteurs exogenes lies a l'origine et a la cause",
    "Facteurs endogenes lies a l'orgine et a la cause",
    "Interactions entre les genes et/ou polymorphismes genetiques",
    "Ressousrces et infrastructures liees a laetiologie",
  ];

  const preventionOption = [
    "Interventions visant a prevenir le cancer : comportements personnels qu",
    "Science de la nutrition et prevention du cancer",
    "chimioprevention",
    "Vaccins",
    "methodes de prevention complementaires et paralleles",
    "Ressoureces et infrasrtructures liees a la prevnetion",
  ];

  const traitementOption = [
    "RadioTheparapie",
    "Chirurgie",
    "Traitement systemique",
    "ChimioTherapie",
    "Hormonotherapie",
    "Therapeutique moleculaires ciblees",
    "Immunotherapie",
  ];

  const Autres_domaines_de_lutte_contre_le_cancerOption = [
    "Analyse des couts et prestation de soins de sante",
    "Sensibilisation et communication",
    "Soins en fin de vie",
    "Ethique et confidentialite dans le domaine de la recherche sur le cancer",
    "Approches complementaires et paralleles en matiere de soins",
    "Ressources et infrastructures liees a la lutte contre le cancer",
  ];

  const Modeles_ScientifiquesOption = [
    "Elaboration et caracterisation de modeles",
    "Application de modeles",
    "Ressources et infrastructures liees aux modeles scientifiques",
  ];

  const handleDomainChange = (e) => {
    setSelectedDomain(e.target.value);
    setFormData({ ...formData, domain: e.target.value });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSavePlaning = async () => {
    const idchercheur = Cookies.get("idchercheur")
      ? parseInt(Cookies.get("idchercheur"))
      : null;
    const idevaluateur = Cookies.get("idevaluateur")
      ? parseInt(Cookies.get("idevaluateur"))
      : null;

    // Ensure all required fields are present
    if (
      !activity ||
      !description ||
      !team ||
      !startDate ||
      !endDate ||
      !totalDays
    ) {
      notifyError("Veuillez remplir tous les champs obligatoires du planning.");
      return;
    }

    const newPlaning = {
      nom_Planning: activity,
      Description_Planning: description,
      id_equipe: parseInt(team), // Ensure team ID is sent as an integer
      idprojet: selectedProjectId, // Use the correct project ID
      debut_planning: startDate,
      fin_planning: endDate,
      nbr_jour_planning: totalDays,
      idchercheur,
      idevaluateur,
    };

    console.log("Planing data being sent to backend:", newPlaning); // Debugging log

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/save_planning.php`,
        JSON.stringify(newPlaning),
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      console.log("Backend response:", response.data); // Debugging log

      if (response.data.success) {
        notifySuccess("Planning enregistré avec succès !");

        if (response.data.id_Planning) {
          // Add the new planning directly to the state
          const savedPlaning = {
            ...newPlaning,
            id_Planning: response.data.id_Planning, // Use the returned id_Planning
          };
          setPlanings((prevPlanings) => [...prevPlanings, savedPlaning]); // Update local state
        } else {
          // Fallback: Fetch the updated list of planings if id_Planning is not returned
          const updatedPlaningsResponse = await axios.get(
            `${process.env.REACT_APP_BASE_URL}/get_planing.php?projectId=${selectedProjectId}`
          );

          if (updatedPlaningsResponse.data.success) {
            setPlanings(updatedPlaningsResponse.data.data); // Update the state with the latest planings
          } else {
            notifyError(
              "Impossible de récupérer les plannings mis à jour : " +
                updatedPlaningsResponse.data.message
            );
          }
        }

        // Clear form fields
        setActivity("");
        setDescription("");
        setTeam("");
        setStartDate("");
        setEndDate("");
        setTotalDays("");
        setIsFormVisiblePlaning(false);
      } else {
        notifyError(
          "Échec de l'enregistrement du planning : " +
            (response.data.message || "Erreur inconnue")
        );
      }
    } catch (error) {
      console.error("Error saving planning:", error);
      notifyError("Une erreur est survenue lors de l'enregistrement du planning.");
    }
  };

  const handleEdit = (index) => {
    const planing = planings[index];
    setActivity(planing.activity);
    setDescription(planing.description);
    setTeam(planing.team);
    setStartDate(planing.startDate);
    setEndDate(planing.endDate);
    setTotalDays(planing.totalDays);
    setIsFormVisiblePlaning(true);
    setEditIndex(index);
  };

  const handleDeletePlaning = async (planingIndex) => {
    const planingToDelete = planings[planingIndex];

    if (!planingToDelete?.id_Planning) {
      notifyError("Impossible de supprimer le planning : identifiant manquant.");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/delete_planing.php`,
        { id_Planning: planingToDelete.id_Planning },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.success) {
        notifySuccess("Planning supprimé avec succès !");
        setPlanings((prevPlanings) =>
          prevPlanings.filter((_, index) => index !== planingIndex)
        );
      } else {
        notifyError("Échec de la suppression du planning : " + response.data.message);
      }
    } catch (error) {
      console.error("Error deleting planning:", error);
      notifyError("Une erreur est survenue lors de la suppression du planning.");
    }
  };

  useEffect(() => {
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      const diffTime = Math.abs(end - start);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // Including the start date
      setTotalDays(diffDays);
    } else {
      setTotalDays("");
    }
  }, [startDate, endDate]);
  const toggleDropdown1 = () => {
    if (areDropdownsVisible) {
      setIsDropdownOpen1(!isDropdownOpen1);
      setIsDropdownOpen2(false);
      setIsDropdownOpne3(false);
      setIsDropdownOpne4(false);
      setIsDropdownOpne5(false);
      setIsDropdownOpen6(false);
      setIsDropdownOpen7(false);
    }
  };

  const toggleDropdown2 = () => {
    if (areDropdownsVisible) {
      setIsDropdownOpen2(!isDropdownOpen2);
      setIsDropdownOpen1(false);
      setIsDropdownOpne3(false);
      setIsDropdownOpne4(false);
      setIsDropdownOpne5(false);
      setIsDropdownOpen6(false);
      setIsDropdownOpen7(false);
    }
  };

  const toggleDropdown3 = () => {
    if (areDropdownsVisible) {
      setIsDropdownOpne3(!isDropdownOpen3);
      setIsDropdownOpen1(false);
      setIsDropdownOpen2(false);
      setIsDropdownOpne4(false);
      setIsDropdownOpne5(false);
      setIsDropdownOpen6(false);
      setIsDropdownOpen7(false);
    }
  };

  const toggleDropdown4 = () => {
    if (areDropdownsVisible) {
      setIsDropdownOpne4(!isDropdownOpen4);
      setIsDropdownOpen1(false);
      setIsDropdownOpen2(false);
      setIsDropdownOpne3(false);
      setIsDropdownOpne5(false);
      setIsDropdownOpen6(false);
      setIsDropdownOpen7(false);
    }
  };

  const toggleDropdown5 = () => {
    if (areDropdownsVisible) {
      setIsDropdownOpne5(!isDropdownOpen5);
      setIsDropdownOpen1(false);
      setIsDropdownOpen2(false);
      setIsDropdownOpne3(false);
      setIsDropdownOpne4(false);
      setIsDropdownOpen6(false);
      setIsDropdownOpen7(false);
    }
  };

  const toggleDropdown6 = () => {
    if (areDropdownsVisible) {
      setIsDropdownOpen6(!isDropdownOpen6);
      setIsDropdownOpen1(false);
      setIsDropdownOpen2(false);
      setIsDropdownOpne3(false);
      setIsDropdownOpne4(false);
      setIsDropdownOpne5(false);
      setIsDropdownOpen7(false);
    }
  };

  const toggleDropdown7 = () => {
    if (areDropdownsVisible) {
      setIsDropdownOpen7(!isDropdownOpen7);
      setIsDropdownOpen1(false);
      setIsDropdownOpen2(false);
      setIsDropdownOpne3(false);
      setIsDropdownOpne4(false);
      setIsDropdownOpne5(false);
      setIsDropdownOpen6(false);
    }
  };

  const closeDropdown1 = () => {
    setIsDropdownOpen1(false);
  };

  const closeDropdown2 = () => {
    setIsDropdownOpen2(false);
  };

  const closeDropdown3 = () => {
    setIsDropdownOpne3(false);
  };

  const closeDropdown4 = () => {
    setIsDropdownOpne4(false);
  };

  const closeDropdown5 = () => {
    setIsDropdownOpne5(false);
  };

  const closeDropdown6 = () => {
    setIsDropdownOpen6(false);
  };

  const closeDropdown7 = () => {
    setIsDropdownOpen7(false);
  };

  const handleToggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const saveProjectData = async () => {
    const idchercheur = Cookies.get("idchercheur")
      ? parseInt(Cookies.get("idchercheur"))
      : null;
    const idevaluateur = Cookies.get("idevaluateur")
      ? parseInt(Cookies.get("idevaluateur"))
      : null;

    // Ensure projectId is set correctly
    const action = projectId ? "updateProject" : "createEmptyProject";

    const dataToSend = {
      action,
      projectId: projectId || null, // Use projectId if available, otherwise null
      projectTitle: formData.projectTitle,
      startDate: formData.startDate,
      endDate: formData.endDate,
      applicationField: formData.applicationField,
      domain: formData.domain,
      subDomain: formData.subDomain,
      totalAmount: formData.totalAmount,
      requestedAmount: formData.requestedAmount,
      idcompetition, // Include idcompetition in the data
      resume: {
        francais: resumeFr,
        anglais: resumeEn,
      },
      miniProject: {
        introduction: intro,
        objectives: objectives,
        methodology: methodology,
        results: results,
        ethics: ethics,
      },
      idchercheur,
      idevaluateur,
    };

    console.log("Data being sent to backend:", dataToSend); // Debugging log

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/projets.php`,
        dataToSend
      );
      console.log("Server response:", response.data);

      if (response.data.status === "success") {
        notifySuccess("Données du projet enregistrées avec succès !");

        // Save returned projectId if it's a new project
        if (!projectId) {
          setSelectedProjectId(response.data.data.projectId);
        }
      } else {
        notifyError("Échec de l'enregistrement des données du projet : " + response.data.message);
      }
    } catch (error) {
      console.error("Error saving project data:", error);
      notifyError("Une erreur est survenue lors de l'enregistrement des données du projet !");
    }
  };

  // Handle changes in member details

  // Remove a member
  const email = Cookies.get("email");

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/allinfouser.php`,
          { email }
        );

        let userInformation = response.data.userInformation;

        // Check if it's a string and attempt to parse it
        if (typeof userInformation === "string") {
          try {
            userInformation = JSON.parse(userInformation);
            console.log("Parsed user information:", userInformation);
          } catch (parseError) {
            console.error("Error parsing user information:", parseError);
            return; // Exit if parsing fails
          }
        }

        setUserInformation(userInformation);
      } catch (error) {
        console.error("Error fetching user information:", error);
      }
    };

    if (email) {
      fetchUserInfo();
    }
  }, [email]);
  console.log("userInfo:", userInfo);
  const handleAddMember = async () => {
    if (
      currentTeamIndex === null ||
      currentTeamIndex === undefined ||
      !teams[currentTeamIndex]
    ) {
      notifyError("Veuillez sélectionner une équipe valide.");
      return;
    }

    const teamId = teams[currentTeamIndex]?.id; // Get the selected team's ID
    console.log("Selected team ID:", teamId); // Debugging log

    if (!teamId) {
      notifyError("L'équipe sélectionnée n'a pas d'ID valide.");
      return;
    }

    // Prepare the request data
    const requestData = {
      teamId, // Pass the team ID
      members: [
        {
          nom: newMember.nom,
          prenom: newMember.prenom,
          civility: newMember.civility || null,
          role: memberRole || "",
          titre: newMember.titre || "",
          email: memberEmail || "",
          specialite: speciality || "",
          structure: structure || "",
          contribution: contribution || "",
          temps_de_travail: workingTime || "",
        },
      ],
    };

    console.log("Data being sent to backend:", requestData);

    try {
      // Send the request to the backend
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/save_equipe.php`,
        JSON.stringify(requestData),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        notifySuccess("Membre ajouté avec succès!");

        // Update local state with the new member
        const updatedTeams = [...teams];

        // Ensure the members array exists
        if (!Array.isArray(updatedTeams[currentTeamIndex]?.members)) {
          updatedTeams[currentTeamIndex].members = []; // Initialize members array
        }

        updatedTeams[currentTeamIndex].members.push(requestData.members[0]);
        setTeams(updatedTeams);

        // Reset the form fields
        setShowForm(false);
        setNewMember({ nom: "", prenom: "", civility: "" });
        setMemberRole("");
        setMemberEmail("");
        setSpeciality("");
        setStructure("");
        setContribution("");
        setWorkingTime("");
      } else {
        notifyError(
          "Erreur lors de l'ajout du membre: " + response.data.message
        );
      }
    } catch (error) {
      console.error("Erreur lors de l'ajout du membre:", error);
      notifyError("Une erreur s'est produite lors de l'ajout du membre.");
    }
  };

  const handleSoumettreProject = async (isCompleteValue) => {
    if (!projectId) {
      notifyError("Aucun projet sélectionné.");
      return;
    }
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/isComplete.php`,
        {
          projectId: projectId,
          isComplete: isCompleteValue,
        }
      );
      if (response.data.status === "success") {
        if (isCompleteValue === 1) {
          setSubmitted(true);
          setShowSoumettre(false);
          notifySuccess("Projet soumis avec succès !");
        } else {
          setSubmitted(false);
          setShowSoumettre(true);
          notifySuccess("Soumission annulée.");
        }
      } else {
        notifyError("Erreur lors de la soumission du projet.");
      }
    } catch (error) {
      notifyError("Erreur réseau lors de la soumission.");
    }
  };

  const handleSaveClick = async () => {
    try {
      const idchercheur = Cookies.get("idchercheur")
        ? parseInt(Cookies.get("idchercheur"))
        : null;

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/projets.php`,
        {
          action: "createEmptyProject",
          idchercheur,
          budgetParametreId, // Include budgetParametreId
          idcompetition, // Include idcompetition
        }
      );

      if (response.data.status === "success") {
        notifySuccess("Nouvelle ligne de projet créée avec succès !");
        if (!location.state?.fromMyProject) {
          setAreDropdownsVisible(true);
        }
        const newProjectId = response.data.data.projectId;
        setShowSoumettre(true); // Show Soumettre after creating a project
        setShowCreerDemande(false); // Hide "Créer une demande" after click
        // Set the button as hidden for the new project id
        localStorage.setItem(`hideCreateButtonClicked_${newProjectId}`, "true");
        setHideCreateButtonClicked(true);
      } else {
          notifyError(
            "Échec de la création d'une nouvelle ligne de projet : " +
              response.data.message
          );
      }
    } catch (error) {
      console.error("Error creating a new project row:", error);
      notifyError("There was an error creating a new project row!");
    }
  };
  const handleAddTeamClick = () => {
    setIsAddingNewTeam(true); // User intends to create a new team
    setIsFormVisible(true); // Show the form for creating a new team
  };

  const handleSaveTeam = async () => {
    if (!newTeamName) {
      notifyError("Veuillez fournir un nom d'équipe.");
      return;
    }

    const effectiveProjectId = selectedProjectId || projectId; // ensure we have a project id for filtering
    if (!effectiveProjectId) {
      notifyError("Project ID indisponible. Enregistrez d'abord le projet.");
      return;
    }

    const newTeam = {
      teamName: newTeamName,
      chefEquipe: userInfo.prenom,
      emailChef: userInfo.email,
      members: [],
    };

    try {
      const teamData = {
        teamName: newTeam.teamName,
        teamLeaderEmail: newTeam.emailChef,
        members: [],
        idprojet: effectiveProjectId,
        idchercheur: Cookies.get("idchercheur")
          ? parseInt(Cookies.get("idchercheur"))
          : null,
        idevaluateur: Cookies.get("idevaluateur")
          ? parseInt(Cookies.get("idevaluateur"))
          : null,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/save_equipe.php`,
        JSON.stringify(teamData),
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.success) {
        notifySuccess("Équipe créée avec succès !");
        const newTeamWithId = {
          ...newTeam,
          id: response.data.teamId,
          idprojet: effectiveProjectId,
        }; // add idprojet so filter shows it immediately
        setTeams((prev) => [...prev, newTeamWithId]);
        setNewTeamName("");
        setIsFormVisible(false);
      } else {
        notifyError("Échec de la création de l'équipe : " + response.data.message);
      }
    } catch (error) {
      console.error("Error creating team:", error);
      notifyError("Une erreur est survenue lors de la création de l'équipe.");
    }
  };

  const [selectedTeamIndex, setSelectedTeamIndex] = useState(null);

  const saveAllDataToDatabase = async () => {
    if (!teams || teams.length === 0) {
      notifyError("Aucune équipe à enregistrer.");
      return;
    }

    const idchercheur = Cookies.get("idchercheur")
      ? parseInt(Cookies.get("idchercheur"))
      : null;
    const idevaluateur = Cookies.get("idevaluateur")
      ? parseInt(Cookies.get("idevaluateur"))
      : null;

    try {
      for (const team of teams) {
        // Prepare team data
        const teamData = {
          teamName: team.teamName,
          teamLeaderEmail: team.emailChef || userInfo.email,
          members: team.members || [], // Include team members
          idprojet: 1,
          idchercheur,
          idevaluateur,
        };

        console.log("Saving team to backend:", teamData);

        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/save_equipe.php`,
          JSON.stringify(teamData),
          {
            headers: { "Content-Type": "application/json" },
          }
        );

        if (!response.data.success) {
          notifyError(
            `Échec de l'enregistrement de l'équipe ${team.teamName} : ` +
              response.data.message
          );
          return;
        }
      }

      notifySuccess("Toutes les équipes et leurs membres ont été enregistrés avec succès !");
    } catch (error) {
      console.error("Error saving data:", error);
      notifyError("Une erreur est survenue lors de l'enregistrement des équipes.");
    }
  };

  console.log("team:", teams);

  // Remove a team member by index
  const handleRemoveMember = (memberIndex) => {
    if (currentTeamIndex !== null) {
      const updatedTeams = [...teams];
      updatedTeams[currentTeamIndex].members.splice(memberIndex, 1);
      setTeams(updatedTeams);
    }
  };

  const openMemberModal = (index) => {
    setCurrentTeamIndex(index); // Save the index of the selected team
    setIsModalOpen(true); // Open the modal
    console.log("Selected team index:", index);
    console.log("Selected team members:", teams[index]?.members); // Debugging log
  };

  const filteredTeams = teams.filter((team) => {
    console.log("Filtering team:", team); // Debugging log for each team
    console.log(
      "Comparing team.idprojet:",
      team.idprojet,
      "with projectId:",
      projectId
    );
    return parseInt(team.idprojet) === parseInt(projectId); // Ensure both are integers
  });

  console.log("Filtered teams for projectId:", projectId, filteredTeams); // Debugging log

  useEffect(() => {
    const fetchTeamsAndMembers = async () => {
      try {
        console.log(
          "Calling API to fetch teams and members for projectId:",
          projectId
        ); // Debugging log
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/get_teamsMembers.php?projectId=${projectId}`
        );

        console.log("API response:", response.data); // Debugging log

        if (response.data.success) {
          console.log(
            "Teams and members fetched successfully:",
            response.data.teams
          ); // Debugging log

          // Patch the teams data to include the idprojet property
          const patchedTeams = response.data.teams.map((team) => ({
            ...team,
            idprojet: projectId, // Add idprojet property
          }));

          setTeams(patchedTeams); // Set patched teams with members
        } else {
          console.error(
            "Failed to fetch teams and members:",
            response.data.message
          );
          setTeams([]); // Clear teams if no data is found
        }
      } catch (error) {
        console.error("Error fetching teams and members:", error);
        setTeams([]); // Clear teams on error
      }
    };

    if (projectId) {
      fetchTeamsAndMembers();
    } else {
      console.error("No projectId provided."); // Debugging log
    }
  }, [projectId]);

  const getTrueDomainsOfInterest = () => {
    if (!userInfo || !userInfo.domaine_dinteret) {
      return "No domain of interest available";
    }

    let domainesDinteret = userInfo.domaine_dinteret;

    try {
      domainesDinteret = JSON.parse(domainesDinteret);
    } catch (error) {
      console.error("Error parsing `domaine_dinteret`:", error);
      return "Invalid domain of interest data";
    }

    if (typeof domainesDinteret !== "object") {
      return "Invalid domain of interest structure";
    }

    const trueChoices = Object.entries(domainesDinteret)
      .filter(([_, value]) => value === true)
      .map(([key]) => key)
      .join(", ");

    return trueChoices || "No true domain found";
  };

  const handleAddTask = (index) => {
    setTaskFormVisible({
      ...taskFormVisible,
      [index]: !taskFormVisible[index],
    });
  };

  const handleSaveTask = async (planingIndex, task) => {
    const selectedPlanning = planings[planingIndex];

    // Ensure id_Planning is available
    if (!selectedPlanning?.id_Planning) {
      notifyError("Impossible d'enregistrer la tâche. L'ID du planning est manquant.");
      return;
    }

    // Ensure all required fields are present
    if (
      !task.name ||
      !task.description ||
      !task.member ||
      !task.startDate ||
      !task.endDate ||
      !task.totalDays
    ) {
      notifyError("Veuillez remplir tous les champs obligatoires de la tâche.");
      return;
    }

    const newTask = {
      nom_tache: task.name,
      description_tache: task.description,
      id_Planning: selectedPlanning.id_Planning, // Use the correct planning ID
      id_equipe: selectedPlanning.id_equipe, // Use the correct team ID
      debut_tache: task.startDate,
      fin_tache: task.endDate,
      nbr_jour_tache: task.totalDays,
    };

    console.log("Task data being sent to backend:", newTask); // Debugging log

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/save_task.php`,
        JSON.stringify(newTask),
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.data.success) {
        notifySuccess("Tâche enregistrée avec succès !");
        const updatedTasks = { ...tasks };
        if (!updatedTasks[planingIndex]) updatedTasks[planingIndex] = [];
        updatedTasks[planingIndex].push(newTask);
        setTasks(updatedTasks); // Update local state
        setTaskFormVisible({ ...taskFormVisible, [planingIndex]: false });
      } else {
        notifyError("Échec de l'enregistrement de la tâche : " + response.data.message);
      }
    } catch (error) {
      console.error("Error saving task:", error);
      notifyError("Une erreur s'est produite lors de l'enregistrement de la tâche.");
    }
  };

  const handleEditTask = (planingIndex, taskIndex) => {
    // Implement edit task functionality here
  };

  const handleDeleteTask = (planingIndex, taskIndex) => {
    const newTasks = { ...tasks };
    newTasks[planingIndex].splice(taskIndex, 1);
    setTasks(newTasks);
  };

  const calculateTotalDays = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffTime = Math.abs(endDate - startDate);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  const fetchProjectData = async (projectId) => {
    try {
      console.log("Fetching project data for projectId:", projectId); // Debugging log
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/projets.php?action=getProjectById&projectId=${projectId}`
      );

      console.log("Backend response:", response.data); // Debugging log

      if (response.data.status === "success") {
        const project = response.data.data || {};
        const isSub =
          project.isComplete === 1 ||
          project.isComplete === "1" ||
          project.is_complete === 1 ||
          project.is_complete === "1" ||
          project.submitted === 1 ||
          project.submitted === "1";
        setSubmitted(Boolean(isSub));
        if (isSub) {
          setShowSoumettre(false);
        }
        setFormData({
          projectTitle: project.titre_projet || "",
          startDate: project.date_debut_projet || "",
          endDate: project.date_fin_projet || "",
          applicationField: project.nom_Champs_dpplication || "",
          domain: project.Domaine || "",
          subDomain: project.sous_domaine || "",
          totalAmount: project.Montant_global || "",
          requestedAmount: project.Montant_subvention || "",
        });
        setResumeFr(project.Resume_francais || "");
        setResumeEn(project.Resume_anglais || "");
        setIntro(project.Introduction_projet || "");
        setObjectives(project.Objectif_general_specifiques || "");
        setMethodology(project.Methodologie_proposee || "");
        setResults(project.resultats_attendus || "");
        setEthics(project.considerations_ethiques || "");
      }
    } catch (error) {
      console.error("Error fetching project data:", error);
      notifyError("An error occurred while fetching the project data.");
    }
  };

  useEffect(() => {
    if (!projectId) {
      console.error("No projectId found in location.state"); // Debugging log
      notifyError(
        "No project ID provided. Please navigate from the MyProject page."
      );
    } else {
      console.log("Received projectId:", projectId); // Debugging log
      setSelectedProjectId(projectId); // Ensure projectId is set in state

      // Automatically show dropdowns if navigated from MyProject.jsx
      if (location.state?.fromMyProject) {
        setAreDropdownsVisible(true);
        setShowCreerDemande(false);
        setShowSoumettre(true);
      }

      fetchProjectData(projectId); // Fetch project data when projectId is available
    }
  }, [projectId]);

  const maxCharLimit = 2000; // Define the character limit
  const maxCharLimitMini = 1000; // Define the character limit for mini-project textareas

  const togglePlaningForm = () => {
    const newState = !isFormVisiblePlaning;
    console.log("Toggling isFormVisiblePlaning:", newState); // Debugging log
    setIsFormVisiblePlaning(newState);
  };

  useEffect(() => {
    const fetchPlanings = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/get_planing.php?projectId=${projectId}`
        );

        if (response.data.success) {
          console.log("Fetched planings:", response.data.data); // Debugging log
          setPlanings(response.data.data); // Update the state with fetched planings
        } else {
          notifyError("Failed to fetch planings: " + response.data.message);
        }
      } catch (error) {
        console.error("Error fetching planings:", error);
        notifyError("An error occurred while fetching the planings.");
      }
    };

    if (projectId) {
      fetchPlanings();
    }
  }, [projectId]);

  const fetchTasksByPlanningId = async (id_Planning) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/get_tasks.php?id_Planning=${id_Planning}`
      );

      if (response.data.success) {
        console.log("Fetched tasks:", response.data.data); // Debugging log
        return response.data.data; // Return the fetched tasks
      } else {
        notifyError("Failed to fetch tasks: " + response.data.message);
        return [];
      }
    } catch (error) {
      console.error("Error fetching tasks:", error);
      notifyError("An error occurred while fetching the tasks.");
      return [];
    }
  };

  const handleViewTasks = async (planingIndex) => {
    const selectedPlanning = planings[planingIndex];
    const tasksForPlanning = await fetchTasksByPlanningId(
      selectedPlanning.id_Planning
    );

    const updatedTasks = { ...tasks };
    updatedTasks[planingIndex] = tasksForPlanning;
    setTasks(updatedTasks); // Update the state with fetched tasks
  };

  const fetchBudgetData = useCallback(async () => {
    if (!projectId) return;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/get_budget.php?idprojet=${projectId}`
      );

      if (response.data.success) {
        console.log("Fetched budget data:", response.data.data); // Debugging log
        setSavedBudgets(response.data.data); // Update the state with fetched budgets
      } else {
        notifyError("Failed to fetch budget data: " + response.data.message);
      }
    } catch (error) {
      console.error("Error fetching budget data:", error);
      notifyError("An error occurred while fetching the budget data.");
    }
  }, [projectId]);

  useEffect(() => {
    fetchBudgetData();
  }, [fetchBudgetData]);

  useEffect(() => {
    if (!savedBudgets.length) return;
    // Enrich budgets with readable names when lookup lists are available
    setSavedBudgets((prev) =>
      prev.map((b) => {
        const section_name =
          b.section_name ||
          filteredSections.find(
            (s) =>
              s.section_id?.toString() === b.ID_ligne_budget_section?.toString()
          )?.section_appellation ||
          "";
        const groupement_name =
          b.groupement_name ||
          filteredGroupements.find(
            (g) =>
              g.groupement_id?.toString() ===
              b.ID_ligne_budget_groupement?.toString()
          )?.groupement_appellation ||
          "";
        const categorie_name =
          b.categorie_name ||
          filteredCategories.find(
            (c) =>
              c.categorie_id?.toString() ===
              b.ID_ligne_budget_categorie?.toString()
          )?.categorie_appellation ||
          "";
        if (section_name || groupement_name || categorie_name) {
          return { ...b, section_name, groupement_name, categorie_name };
        }
        return b;
      })
    );
  }, [filteredSections, filteredGroupements, filteredCategories]);

  return (
    <div>
      <ToastContainer />
      
      <Sidebar/>
      <div className="dropdown-container">
        {submitted && fromMyProject && (
          <div
            style={{
              background: "#fde68a",
              border: "1px solid #f59e0b",
              color: "#92400e",
              padding: "10px 14px",
              borderRadius: 8,
              marginBottom: 16,
              fontWeight: 600,
            }}
          >
            Projet soumis - lecture seule. Aucune modification autorisée.
          </div>
        )}
        <div className="header-container">
          <div className="record-id">
            <p style={{ margin: 0 }}>№ du Projet: {projectId}</p>
            <p style={{ margin: 0 }}>
              Le projet doit être envoyé à l'IRC avant le{" "}
              <strong>{date_fin || "Date non disponible"}</strong>. Vous pouvez
              trouver l'ensemble des conditions d'admissibilité dans la barre
              ci-dessus, section <Link to="/documents">'Documents'</Link>. Nous
              vous invitons à bien prendre connaissance du contenu de la
              fiche du programme.
            </p>
          </div>
          {/* Show "Créer une demande" only if allowed */}
          {showCreerDemande && (
            <div className="save-button">
              <button
                onClick={() => {
                  handleSaveClick();
                }}
              >
                Créer une demande
              </button>
            </div>
          )}
        </div>
        {/* ...existing code... */}
        {areDropdownsVisible && (
          <>
            {/* Coordonnateur principal Dropdown */}
            <div className="dropdown">
              <div className="dropdown-title-wrapper" onClick={toggleDropdown1}>
                <div className="dropdown-title">Coordonnateur principal</div>
                <div className="dropdown-flesh">&#x25B6;</div>
              </div>
              <div
                className={`dropdown-content ${isDropdownOpen1 ? "show" : ""}`}
              >
                {userInfo ? (
                  <>
                    <p>
                      {" "}
                      <h1 style={{ color: "black" }}>Appel A Compitition</h1>
                    </p>
                    <p className="item">
                      <strong>Nom</strong>
                    </p>
                    <input
                      type="text"
                      placeholder="Nom"
                      value={userInfo.nom}
                      readOnly
                    />
                    <p className="item">
                      <strong>Prénom</strong>
                    </p>
                    <input
                      type="text"
                      placeholder="Prénom"
                      value={userInfo.prenom}
                      readOnly
                    />
                    <p className="item">
                      <strong>Date de naissance</strong>
                    </p>
                    <input
                      type="text"
                      placeholder="Date de naissance"
                      value={userInfo.datenaissance}
                      readOnly
                    />
                    <p className="item">
                      <strong>E-mail</strong>
                    </p>
                    <input
                      type="text"
                      placeholder="Email"
                      readOnly
                      value={userInfo.email}
                    />
                    <p className="item">
                      <strong>Téléphone</strong>
                    </p>
                    <input
                      type="text"
                      placeholder="Téléphone"
                      value={userInfo.telephone}
                      readOnly
                    />
                    <p className="item">
                      <strong>Spécialité</strong>
                    </p>
                    <input
                      type="text"
                      placeholder="Spécialité"
                      value={userInfo.specialite}
                      readOnly
                    />
                    <p className="item">
                      <strong>Type d'organisme</strong>
                    </p>
                    <input
                      type="text"
                      placeholder="Type d'organisme"
                      value={userInfo.type_organisme}
                      readOnly
                    />
                    <p className="item">
                      <strong>Domaine d'intérêt</strong>
                    </p>
                    <input
                      type="text"
                      placeholder="Domaine d'intérêt"
                      value={getTrueDomainsOfInterest()}
                      readOnly
                    />
                    <p className="item">
                      <strong>Spécialité de formation</strong>
                    </p>
                    <input
                      type="text"
                      placeholder="Spécialité de formation"
                      readOnly
                      value={userInfo.specialite_formation}
                    />
                    <p className="item">
                      <strong>Domaine de maîtrise</strong>
                    </p>
                    <input
                      type="text"
                      placeholder="Domaine de maîtrise"
                      readOnly
                      value={userInfo.domaine_maitrise}
                    />
                    <p className="item">
                      <strong>Statut</strong>
                    </p>
                    <input
                      type="text"
                      placeholder="Statut"
                      value={userInfo.statut}
                      readOnly
                    />
                    <p className="item">
                      <strong>Organisme sélectionné</strong>
                    </p>
                    <input
                      type="text"
                      placeholder="Organisme sélectionné"
                      value={userInfo.selected_organisme}
                      readOnly
                    />
                    <div className="dropdown-buttons">
                      <button onClick={closeDropdown1}>fermer</button>
                    </div>
                  </>
                ) : (
                  <p>Loading...</p>
                )}
              </div>
            </div>
            {/* Secondaire Dropdown */}
            <div className="dropdown">
              <div className="dropdown-title-wrapper" onClick={toggleDropdown2}>
                <div className="dropdown-title">Informations générales</div>
                <div className="dropdown-flesh">&#x25B6;</div>
              </div>
              <div
                className={`dropdown-content ${isDropdownOpen2 ? "show" : ""}`}
              >
                {userInfo ? (
                  <>
                    <h1 style={{ color: "black" }}>Informations générales</h1>
                    <p className="item">
                      <strong>Titre du projet</strong>
                    </p>
                    <input
                      type="text"
                      placeholder="Titre du projet"
                      name="projectTitle"
                      value={formData.projectTitle}
                      onChange={handleChange}
                      readOnly={ro}
                    />
                    <p className="item">
                      <strong>Date prévisionnelle du début du projet</strong>
                    </p>
                    <input
                      type="date"
                      placeholder="Date prévisionnelle du début du projet"
                      name="startDate"
                      value={formData.startDate}
                      onChange={handleChange}
                      readOnly={ro}
                    />
                    <p className="item">
                      <strong>Date de fin du projet</strong>
                    </p>
                    <input
                      type="date"
                      placeholder="Date de fin du projet"
                      name="endDate"
                      value={formData.endDate}
                      onChange={handleChange}
                      readOnly={ro}
                    />
                    <p className="item">
                      <strong>Champs d’application </strong>
                    </p>
                    <select
                      name="applicationField"
                      className="select-feild"
                      id=""
                      value={formData.applicationField}
                      onChange={handleChange}
                      disabled={ro}
                    >
                      <option value="">
                        Choisire Votre Champs D’application
                      </option>
                      <option>Epidemiologie, Sante Publique</option>
                      <option>Managment / Offre de soins</option>
                      <option>
                        Base de donnees/ Techniquess d'information et de
                        communication
                      </option>
                      <option>Biologie moleculaire / Recherche clinique</option>
                      <option>Recherche clinique</option>
                      <option>Recherche Translationnelle</option>
                      <option>Socio-anthropologie</option>
                      <option>Communication / Education sanitaire</option>
                    </select>
                    <p className="item">
                      <strong>Domaines et sous-domaines de recherche</strong>
                    </p>
                    <select
                      name="domain"
                      className="select-feild"
                      onChange={handleDomainChange}
                      value={formData.domain}
                      disabled={ro}
                    >
                      <option value="">
                        Choisir Votre Domaine de Recherche
                      </option>
                      <option value="Biologie">Biologie</option>
                      <option value="Etiologie">Étiologie</option>
                      <option value="Prevention">Prévention</option>
                      <option value="Traitement">Traitement</option>
                      <option value="Autres domaines de lutte contre le cancer">
                        Autres domaines de lutte contre le cancer
                      </option>
                      <option value="Modeles Scientifique">
                        Modèles Scientifiques
                      </option>
                    </select>
                    {selectedDomain === "Biologie" && (
                      <select
                        name="subDomain"
                        className="select-feild"
                        value={formData.subDomain}
                        onChange={handleChange}
                        disabled={ro}
                      >
                        <option value="">Sélectionner une option</option>
                        {biologyOptions.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    )}
                    {selectedDomain === "Etiologie" && (
                      <select
                        name="subDomain"
                        className="select-feild"
                        value={formData.subDomain}
                        onChange={handleChange}
                        disabled={ro}
                      >
                        <option value="">Sélectionner une option</option>
                        {etiologieOptions.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    )}
                    {selectedDomain === "Prevention" && (
                      <select
                        name="subDomain"
                        className="select-feild"
                        value={formData.subDomain}
                        onChange={handleChange}
                        disabled={ro}
                      >
                        <option value="">Sélectionner une option</option>
                        {preventionOption.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    )}
                    {selectedDomain === "Traitement" && (
                      <select
                        name="subDomain"
                        className="select-feild"
                        value={formData.subDomain}
                        onChange={handleChange}
                        disabled={ro}
                      >
                        <option value="">Sélectionner une option</option>
                        {traitementOption.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    )}
                    {selectedDomain ===
                      "Autres domaines de lutte contre le cancer" && (
                      <select
                        name="subDomain"
                        className="select-feild"
                        value={formData.subDomain}
                        onChange={handleChange}
                        disabled={ro}
                      >
                        <option value="">Sélectionner une option</option>
                        {Autres_domaines_de_lutte_contre_le_cancerOption.map(
                          (option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                          )
                        )}
                      </select>
                    )}
                    {selectedDomain === "Modeles Scientifique" && (
                      <select
                        name="subDomain"
                        className="select-feild"
                        value={formData.subDomain}
                        onChange={handleChange}
                        disabled={ro}
                      >
                        <option value="">Sélectionner une option</option>
                        {Modeles_ScientifiquesOption.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    )}

                    <p className="item">
                      <strong>Montant global du projet (MAD)</strong>
                    </p>
                    <input
                      type="number"
                      placeholder="Montant global du Projet"
                      name="totalAmount"
                      value={formData.totalAmount}
                      onChange={handleChange}
                      readOnly={ro}
                    />
                    <p className="item">
                      <strong>
                        Montant de la subvention demandé à l'IRC (MAD)
                      </strong>
                    </p>
                    <input
                      type="number"
                      placeholder="Monatant de subvention"
                      name="requestedAmount"
                      value={formData.requestedAmount}
                      onChange={handleChange}
                      readOnly={ro}
                    />
                    <div className="dropdown-buttons">
                      {showSave && (
                        <button onClick={saveProjectData}>Enregistrer</button>
                      )}
                      <button onClick={closeDropdown2}>Fermer</button>
                    </div>
                  </>
                ) : (
                  <p>Loading...</p>
                )}
              </div>
            </div>
            <div className="dropdown">
              <div className="dropdown-title-wrapper" onClick={toggleDropdown3}>
                <div className="dropdown-title">Résumé</div>
                <div className="dropdown-flesh">&#x25B6;</div>
              </div>
              <div
                className={`dropdown-content ${isDropdownOpen3 ? "show" : ""}`}
              >
                <>
                  <h1 style={{ color: "black" }}>Résumé</h1>
                  <p className="text-left">
                    <strong>
                      Décrire : <br />
                      -L'état de l'art du projet,
                      <br /> -Les Objectifs,
                      <br />
                      -La méthodologie, <br /> -Les Résultats.
                    </strong>
                  </p>
                  <p className="text-left">
                    N.B : Si le projet est sélectionné et financé, son résumé
                    pourrait faire l'objet de publication sur le site internet
                    de l'IRC.
                  </p>
                  <div className="container-resume">
                    <p className="text-left">
                      Résumé en <strong> francais </strong> décrivant : L'état
                      de l'art du projet, Les objectifs, La méthodologie, Les
                      résultats escomptés
                    </p>
                    <div style={{ position: "relative" }}>
                      <textarea
                        value={resumeFr}
                        onChange={(e) => {
                          if (e.target.value.length <= maxCharLimit) {
                            setResumeFr(e.target.value);
                          }
                        }}
                        style={{
                          width: "100%",
                          padding: "10px",
                          boxSizing: "border-box",
                        }}
                        readOnly={ro}
                      ></textarea>
                      <span
                        style={{
                          position: "absolute",
                          bottom: "5px",
                          right: "10px",
                          fontSize: "12px",
                          color:
                            resumeFr.length === maxCharLimit ? "red" : "gray",
                        }}
                      >
                        {resumeFr.length}/{maxCharLimit}
                      </span>
                    </div>
                  </div>
                  <div className="container-resume">
                    <p className="text-left">
                      Résumé en <strong> Anglais </strong> décrivant : L'état de
                      l'art du projet, Les objectifs, La méthodologie, Les
                      résultats escomptés
                    </p>
                    <div style={{ position: "relative" }}>
                      <textarea
                        value={resumeEn}
                        onChange={(e) => {
                          if (e.target.value.length <= maxCharLimit) {
                            setResumeEn(e.target.value);
                          }
                        }}
                        style={{
                          width: "100%",
                          padding: "10px",
                          boxSizing: "border-box",
                        }}
                        readOnly={ro}
                      ></textarea>
                      <span
                        style={{
                          position: "absolute",
                          bottom: "5px",
                          right: "10px",
                          fontSize: "12px",
                          color:
                            resumeEn.length === maxCharLimit ? "red" : "gray",
                        }}
                      >
                        {resumeEn.length}/{maxCharLimit}
                      </span>
                    </div>
                  </div>
                  <div className="dropdown-buttons">
                    {showSave && (
                      <button onClick={saveProjectData}>Enregistrer</button>
                    )}
                    <button onClick={closeDropdown3}>Fermer</button>
                  </div>
                </>
              </div>
            </div>
            <div className="dropdown">
              <div className="dropdown-title-wrapper" onClick={toggleDropdown4}>
                <div className="dropdown-title">Description du mini-projet</div>
                <div className="dropdown-flesh">&#x25B6;</div>
              </div>
              <div
                className={`dropdown-content ${isDropdownOpen4 ? "show" : ""}`}
              >
                <>
                  <h1 style={{ color: "black" }}>Description du mini-projet</h1>
                  <div className="container-resume-mini">
                    <p className="text-left">Introduction*</p>
                    <div style={{ position: "relative" }}>
                      <textarea
                        value={intro}
                        onChange={(e) => {
                          if (e.target.value.length <= maxCharLimitMini) {
                            setIntro(e.target.value);
                          }
                        }}
                        style={{
                          width: "100%",
                          padding: "10px",
                          boxSizing: "border-box",
                        }}
                        readOnly={ro}
                      ></textarea>
                      <span
                        style={{
                          position: "absolute",
                          bottom: "5px",
                          right: "10px",
                          fontSize: "12px",
                          color:
                            intro.length === maxCharLimitMini ? "red" : "gray",
                        }}
                      >
                        {intro.length}/{maxCharLimitMini}
                      </span>
                    </div>
                  </div>
                  <div className="container-resume-mini">
                    <p className="text-left">
                      Objectif général et objectifs spécifiques du projet *
                    </p>
                    <div style={{ position: "relative" }}>
                      <textarea
                        value={objectives}
                        onChange={(e) => {
                          if (e.target.value.length <= maxCharLimitMini) {
                            setObjectives(e.target.value);
                          }
                        }}
                        style={{
                          width: "100%",
                          padding: "10px",
                          boxSizing: "border-box",
                        }}
                        readOnly={ro}
                      ></textarea>
                      <span
                        style={{
                          position: "absolute",
                          bottom: "5px",
                          right: "10px",
                          fontSize: "12px",
                          color:
                            objectives.length === maxCharLimitMini
                              ? "red"
                              : "gray",
                        }}
                      >
                        {objectives.length}/{maxCharLimitMini}
                      </span>
                    </div>
                  </div>
                  <div className="container-resume-mini">
                    <p className="text-left">Méthodologie proposée*</p>
                    <div style={{ position: "relative" }}>
                      <textarea
                        value={methodology}
                        onChange={(e) => {
                          if (e.target.value.length <= maxCharLimitMini) {
                            setMethodology(e.target.value);
                          }
                        }}
                        style={{
                          width: "100%",
                          padding: "10px",
                          boxSizing: "border-box",
                        }}
                        readOnly={ro}
                      ></textarea>
                      <span
                        style={{
                          position: "absolute",
                          bottom: "5px",
                          right: "10px",
                          fontSize: "12px",
                          color:
                            methodology.length === maxCharLimitMini
                              ? "red"
                              : "gray",
                        }}
                      >
                        {methodology.length}/{maxCharLimitMini}
                      </span>
                    </div>
                  </div>
                  <div className="container-resume-mini">
                    <p className="text-left">
                      Résultats attendus et impacts du mini-projet*
                    </p>
                    <div style={{ position: "relative" }}>
                      <textarea
                        value={results}
                        onChange={(e) => {
                          if (e.target.value.length <= maxCharLimitMini) {
                            setResults(e.target.value);
                          }
                        }}
                        style={{
                          width: "100%",
                          padding: "10px",
                          boxSizing: "border-box",
                        }}
                        readOnly={ro}
                      ></textarea>
                      <span
                        style={{
                          position: "absolute",
                          bottom: "5px",
                          right: "10px",
                          fontSize: "12px",
                          color:
                            results.length === maxCharLimitMini
                              ? "red"
                              : "gray",
                        }}
                      >
                        {results.length}/{maxCharLimitMini}
                      </span>
                    </div>
                  </div>
                  <div className="container-resume-mini">
                    <p className="text-left">Considérations éthiques*</p>
                    <div style={{ position: "relative" }}>
                      <textarea
                        value={ethics}
                        onChange={(e) => {
                          if (e.target.value.length <= maxCharLimitMini) {
                            setEthics(e.target.value);
                          }
                        }}
                        style={{
                          width: "100%",
                          padding: "10px",
                          boxSizing: "border-box",
                        }}
                        readOnly={ro}
                      ></textarea>
                      <span
                        style={{
                          position: "absolute",
                          bottom: "5px",
                          right: "10px",
                          fontSize: "12px",
                          color:
                            ethics.length === maxCharLimitMini ? "red" : "gray",
                        }}
                      >
                        {ethics.length}/{maxCharLimitMini}
                      </span>
                    </div>
                  </div>
                  <div className="dropdown-buttons">
                    {showSave && (
                      <button onClick={saveProjectData}>Enregistrer</button>
                    )}
                    <button onClick={closeDropdown4}>Fermer</button>
                  </div>
                </>
              </div>
            </div>
            <div className="dropdown">
              <div className="dropdown-title-wrapper" onClick={toggleDropdown5}>
                <div className="dropdown-title">Créer votre équipe</div>
                <div className="dropdown-flesh">&#x25B6;</div>
              </div>
              <div
                className={`dropdown-content ${isDropdownOpen5 ? "show" : ""}`}
              >
                <h1 style={{ color: "black", fontSize: "1.7rem" }}>
                  Créer votre équipe
                </h1>
                {!isFormVisible && showSave && (
                  <div className="dropdown-buttons">
                    <button onClick={handleAddTeamClick}>
                      Ajouter une équipe
                    </button>
                  </div>
                )}

                {!isFormVisible && filteredTeams.length > 0 && (
                  <>
                    <h3>Équipe Détails</h3>
                    <table>
                      <thead>
                        <tr>
                          <th>Nom d'équipe</th>
                          <th>Membres</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredTeams.map((team, index) => (
                          <tr key={index}>
                            <td>{team.teamName || team.nom_equipe}</td>{" "}
                            {/* Ensure correct property */}
                            <td>
                              <button
                                onClick={() => openMemberModal(index)}
                                className="show-members-btn"
                              >
                                Afficher les membres
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="dropdown-buttons">
                      <button onClick={closeDropdown5}>Fermer</button>
                    </div>
                  </>
                )}

                {!isFormVisible && filteredTeams.length === 0 && (
                  <p>Aucune équipe trouvée pour ce projet.</p>
                )}

                {isFormVisible && (
                  <div className="form-container">
                    <h1 style={{ color: "black" }}>Nouvelle Équipe</h1>
                    <div>
                      <p>
                        <strong>Nom d'équipe:</strong>
                      </p>
                      <input
                        type="text"
                        value={newTeamName}
                        onChange={(e) => setNewTeamName(e.target.value)}
                        placeholder="Nom d'équipe"
                      />
                    </div>
                    <div>
                      <p>
                        <strong>Chef d'équipe:</strong>
                      </p>
                      <input
                        type="text"
                        value={userInfo.prenom}
                        placeholder="Chef d'équipe"
                        readOnly
                      />
                    </div>
                    <div>
                      <p>
                        <strong>Email du chef:</strong>
                      </p>
                      <input
                        type="email"
                        value={userInfo.email}
                        placeholder="Email du chef"
                        readOnly
                      />
                    </div>
                    <div className="dropdown-buttons">
                      {showSave && (
                        <button onClick={handleSaveTeam}>Enregistrer</button>
                      )}
                      <button onClick={() => setIsFormVisible(false)}>
                        Fermer
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="dropdown">
              <div className="dropdown-title-wrapper" onClick={toggleDropdown6}>
                <div className="dropdown-title">Planing</div>
                <div className="dropdown-flesh">&#x25B6;</div>
              </div>
              <div
                className={`dropdown-content ${isDropdownOpen6 ? "show" : ""}`}
              >
                <>
                  <h1 style={{ color: "black", fontSize: "1.7rem" }}>
                    Planing
                  </h1>
                  <div className="dropdown-buttons">
                    {showSave && (
                      <button
                        onClick={() =>
                          setIsFormVisiblePlaning(!isFormVisiblePlaning)
                        }
                      >
                        {isFormVisiblePlaning
                          ? "Annuler"
                          : "Ajouter un Planing"}
                      </button>
                    )}
                  </div>

                  {isFormVisiblePlaning && (
                    <div className="planing-form-container">
                      <div className="planing-form-group">
                        <p className="item">
                          <strong>Activité:</strong>
                        </p>
                        <input
                          type="text"
                          value={activity}
                          onChange={(e) => setActivity(e.target.value)}
                          placeholder="Activité"
                        />
                      </div>
                      <div className="planing-form-group">
                        <p className="item">
                          <strong>Description:</strong>
                        </p>
                        <input
                          type="text"
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                          placeholder="Description"
                        />
                      </div>
                      <div className="planing-form-group-inline">
                        <div className="planing-form-group">
                          <p className="item">
                            <strong>Équipe:</strong>
                          </p>
                          <select
                            className="select-feild"
                            value={team}
                            onChange={(e) => setTeam(e.target.value)}
                            placeholder="Sélectionnez une équipe"
                            disabled={ro}
                          >
                            <option value="">Sélectionnez une équipe</option>
                            {teams.map((teamItem) => (
                              <option key={teamItem.id} value={teamItem.id}>
                                {teamItem.teamName}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="planing-form-group-inline">
                        <div className="planing-form-group">
                          <p className="item">
                            <strong>Date début:</strong>
                          </p>
                          <input
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            disabled={ro}
                          />
                        </div>
                        <div className="planing-form-group">
                          <p className="item">
                            <strong>Date fin:</strong>
                          </p>
                          <input
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            disabled={ro}
                          />
                        </div>
                        <div className="planing-form-group">
                          <p className="item">
                            <strong>Total des jours:</strong>
                          </p>
                          <input
                            type="number"
                            value={totalDays}
                            readOnly
                            placeholder="Total des jours"
                          />
                        </div>
                      </div>
                      <div className="dropdown-buttons">
                        {showSave && (
                          <button onClick={handleSavePlaning}>
                            Enregistrer
                          </button>
                        )}
                        <button onClick={() => setIsFormVisiblePlaning(false)}>
                          Fermer
                        </button>
                      </div>
                    </div>
                  )}

                  {planings.length > 0 && (
                    <div>
                      <p>
                        <strong>Planings créés</strong>
                      </p>
                      <table className="planing-table">
                        <thead>
                          <tr>
                            <th>Activité</th>
                            <th>Description</th>
                            <th>Équipe</th>
                            <th>Date début</th>
                            <th>Date fin</th>
                            <th>Total des jours</th>
                            <th>Option</th>
                          </tr>
                        </thead>
                        <tbody>
                          {planings.map((planing, planingIndex) => (
                            <tr key={planingIndex}>
                              <td>{planing.nom_Planning}</td>
                              <td>{planing.Description_Planning}</td>
                              <td>{planing.id_equipe}</td>
                              <td>{planing.debut_planning}</td>
                              <td>{planing.fin_planning}</td>
                              <td>{planing.nbr_jour_planning}</td>
                              <td className="planing-dropdown-buttons">
                                {showSave && (
                                  <>
                                    <button
                                      onClick={() => handleEdit(planingIndex)}
                                    >
                                      Modifier
                                    </button>
                                    <button
                                      onClick={() =>
                                        handleDeletePlaning(planingIndex)
                                      }
                                    >
                                      Supprimer
                                    </button>
                                    <button
                                      onClick={() =>
                                        handleAddTask(planingIndex)
                                      }
                                    >
                                      Ajouter Tâche
                                    </button>
                                  </>
                                )}
                                <button
                                  onClick={() => handleViewTasks(planingIndex)}
                                >
                                  Voir Tâches
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      {Object.keys(taskFormVisible).map(
                        (index) =>
                          taskFormVisible[index] && (
                            <div key={index} className="task-form-container">
                              <div className="task-form-group">
                                <p className="item">
                                  <strong>Nom Tâche:</strong>
                                </p>
                                <input
                                  type="text"
                                  placeholder="Nom Tâche"
                                  onChange={(e) => setTaskName(e.target.value)}
                                />
                              </div>
                              <div className="task-form-group">
                                <p className="item">
                                  <strong>Description:</strong>
                                </p>
                                <input
                                  type="text"
                                  placeholder="Description"
                                  onChange={(e) =>
                                    setTaskDescription(e.target.value)
                                  }
                                />
                              </div>
                              <div className="task-form-group">
                                <p className="item">
                                  <strong>Membre de l'équipe:</strong>
                                </p>
                                <input
                                  type="text"
                                  placeholder="Membre de l'équipe"
                                  onChange={(e) =>
                                    setTaskMember(e.target.value)
                                  }
                                />
                              </div>
                              <div className="task-form-group">
                                <p className="item">
                                  <strong>Date début:</strong>
                                </p>
                                <input
                                  type="date"
                                  onChange={(e) =>
                                    setTaskStartDate(e.target.value)
                                  }
                                />
                              </div>
                              <div className="task-form-group">
                                <p className="item">
                                  <strong>Date fin:</strong>
                                </p>
                                <input
                                  type="date"
                                  onChange={(e) =>
                                    setTaskEndDate(e.target.value)
                                  }
                                />
                              </div>
                              <div className="task-form-group">
                                <p className="item">
                                  <strong>Total des jours:</strong>
                                </p>
                                <input
                                  type="number"
                                  readOnly
                                  placeholder="Total des jours"
                                  value={calculateTotalDays(
                                    taskStartDate,
                                    taskEndDate
                                  )}
                                />
                              </div>
                              <div className="dropdown-buttons">
                                {showSave && (
                                  <button
                                    onClick={() =>
                                      handleSaveTask(index, {
                                        name: taskName,
                                        description: taskDescription,
                                        member: taskMember,
                                        startDate: taskStartDate,
                                        endDate: taskEndDate,
                                        totalDays: calculateTotalDays(
                                          taskStartDate,
                                          taskEndDate
                                        ),
                                      })
                                    }
                                  >
                                    Enregistrer
                                  </button>
                                )}
                                <button
                                  onClick={() =>
                                    setTaskFormVisible({
                                      ...taskFormVisible,
                                      [index]: false,
                                    })
                                  }
                                >
                                  Fermer
                                </button>
                              </div>
                            </div>
                          )
                      )}

                      {Object.keys(tasks).map((planingIndex) => (
                        <div key={planingIndex}>
                          <p>
                            <strong>
                              Tâches pour {planings[planingIndex].nom_Planning}:
                            </strong>
                          </p>
                          <table className="task-table">
                            <thead style={{ color: "black" }}>
                              <tr>
                                <th>Nom Tâche</th>
                                <th>Description</th>
                                <th>Membre de l'équipe</th>
                                <th>Date début</th>
                                <th>Date fin</th>
                                <th>Total des jours</th>
                              </tr>
                            </thead>
                            <tbody>
                              {tasks[planingIndex].map((task, taskIndex) => (
                                <tr key={taskIndex}>
                                  <td>{task.nom_tache}</td>
                                  <td>{task.description_tache}</td>
                                  <td>{task.id_equipe}</td>
                                  <td>{task.debut_tache}</td>
                                  <td>{task.fin_tache}</td>
                                  <td>{task.nbr_jour_tache}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ))}
                    </div>
                  )}
                  <div className="dropdown-buttons">
                    <button onClick={closeDropdown6}>Fermer</button>
                  </div>
                </>
              </div>
            </div>
            <div className="dropdown">
              <div className="dropdown-title-wrapper" onClick={toggleDropdown7}>
                <div className="dropdown-title">Budget</div>
                <div className="dropdown-flesh">&#x25B6;</div>
              </div>
              <div
                className={`dropdown-content ${isDropdownOpen7 ? "show" : ""}`}
              >
                <h1 style={{ color: "black" }}>Budget</h1>
                <div>
                  <p className="item">
                    <strong>Section:</strong>
                  </p>
                  <select
                    name="section"
                    className="select-feild"
                    value={selectedSectionId}
                    onChange={(e) => {
                      setSelectedSectionId(e.target.value);
                      setSelectedGroupementId("");
                      setSelectedCategorieId("");
                    }}
                  >
                    <option value="">Select Section</option>
                    {filteredSections.map((section) => (
                      <option key={section.section_id} value={section.section_id}>
                        {section.section_appellation}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <p className="item">
                    <strong>Groupement:</strong>
                  </p>
                  <select
                    name="groupement"
                    className="select-feild"
                    value={selectedGroupementId}
                    onChange={(e) => {
                      setSelectedGroupementId(e.target.value);
                      setSelectedCategorieId("");
                    }}
                  >
                    <option value="">Select Groupement</option>
                    {filteredGroupements
                      .filter((g) =>
                        selectedSectionId
                          ? String(g.groupement_section_id) ===
                            String(selectedSectionId)
                          : true
                      )
                      .map((groupement) => (
                        <option
                          key={groupement.groupement_id}
                          value={groupement.groupement_id}
                        >
                          {groupement.groupement_appellation}
                        </option>
                      ))}
                  </select>
                </div>
                <div>
                  <p className="item">
                    <strong>Catégorie:</strong>
                  </p>
                  <select
                    name="categorie"
                    className="select-feild"
                    value={selectedCategorieId}
                    onChange={(e) => setSelectedCategorieId(e.target.value)}
                  >
                    <option value="">Select Catégorie</option>
                    {filteredCategories
                      .filter((c) => {
                        if (selectedGroupementId) {
                          return (
                            String(c.categorie_groupement_id) ===
                            String(selectedGroupementId)
                          );
                        }
                        if (selectedSectionId) {
                          // Show only categories whose groupement belongs to selected section
                          const parentGroupement = filteredGroupements.find(
                            (g) =>
                              String(g.groupement_id) ===
                              String(c.categorie_groupement_id)
                          );
                          return (
                            parentGroupement &&
                            String(parentGroupement.groupement_section_id) ===
                              String(selectedSectionId)
                          );
                        }
                        return true;
                      })
                      .map((categorie) => (
                        <option
                          key={categorie.categorie_id}
                          value={categorie.categorie_id}
                        >
                          {categorie.categorie_appellation}
                        </option>
                      ))}
                  </select>
                </div>
                <div>
                  <p className="item">
                    <strong>Description:</strong>
                  </p>
                  <input
                    type="text"
                    name="description"
                    placeholder="Description"
                  />
                </div>
                <div>
                  <p className="item">
                    <strong>Montant du budget:</strong>
                  </p>
                  <input
                    type="number"
                    name="budgetAmount"
                    placeholder="Montant du budget"
                  />
                </div>
                <div>
                  <h2>Budgets</h2>
                  <table border="1">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Section</th>
                        <th>Groupement</th>
                        <th>Catégorie</th>
                        <th>Description</th>
                        <th>Montant</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {savedBudgets.map((budget, index) => {
                        const sectionLabel =
                          budget.section_name ||
                          filteredSections.find(
                            (s) =>
                              s.section_id?.toString() ===
                              budget.ID_ligne_budget_section?.toString()
                          )?.section_appellation ||
                          "";
                        const groupementLabel =
                          budget.groupement_name ||
                          filteredGroupements.find(
                            (g) =>
                              g.groupement_id?.toString() ===
                              budget.ID_ligne_budget_groupement?.toString()
                          )?.groupement_appellation ||
                          "";
                        const categorieLabel =
                          budget.categorie_name ||
                          filteredCategories.find(
                            (c) =>
                              c.categorie_id?.toString() ===
                              budget.ID_ligne_budget_categorie?.toString()
                          )?.categorie_appellation ||
                          "";
                        return (
                          <tr key={index}>
                            <td>{budget.id_budget_projet}</td>
                            <td>
                              {editingBudgetIndex === index ? (
                                <select
                                  className="select-feild"
                                  value={editSectionId}
                                  onChange={(e) => {
                                    setEditSectionId(e.target.value);
                                    setEditGroupementId("");
                                    setEditCategorieId("");
                                  }}
                                >
                                  <option value="">Sélectionner une section</option>
                                  {filteredSections.map((section) => (
                                    <option
                                      key={section.section_id}
                                      value={section.section_id}
                                    >
                                      {section.section_appellation}
                                    </option>
                                  ))}
                                </select>
                              ) : (
                                sectionLabel
                              )}
                            </td>
                            <td>
                              {editingBudgetIndex === index ? (
                                <select
                                  className="select-feild"
                                  value={editGroupementId}
                                  onChange={(e) => {
                                    setEditGroupementId(e.target.value);
                                    setEditCategorieId("");
                                  }}
                                >
                                  <option value="">
                                    Sélectionner un groupement
                                  </option>
                                  {filteredGroupements
                                    .filter((g) =>
                                      editSectionId
                                        ? String(g.groupement_section_id) ===
                                          String(editSectionId)
                                        : true
                                    )
                                    .map((groupement) => (
                                      <option
                                        key={groupement.groupement_id}
                                        value={groupement.groupement_id}
                                      >
                                        {groupement.groupement_appellation}
                                      </option>
                                    ))}
                                </select>
                              ) : (
                                groupementLabel
                              )}
                            </td>
                            <td>
                              {editingBudgetIndex === index ? (
                                <select
                                  className="select-feild"
                                  value={editCategorieId}
                                  onChange={(e) => setEditCategorieId(e.target.value)}
                                >
                                  <option value="">Sélectionner une catégorie</option>
                                  {filteredCategories
                                    .filter((c) => {
                                      if (editGroupementId) {
                                        return (
                                          String(c.categorie_groupement_id) ===
                                          String(editGroupementId)
                                        );
                                      }
                                      if (editSectionId) {
                                        const parent = filteredGroupements.find(
                                          (g) =>
                                            String(g.groupement_id) ===
                                            String(c.categorie_groupement_id)
                                        );
                                        return (
                                          parent &&
                                          String(parent.groupement_section_id) ===
                                            String(editSectionId)
                                        );
                                      }
                                      return true;
                                    })
                                    .map((categorie) => (
                                      <option
                                        key={categorie.categorie_id}
                                        value={categorie.categorie_id}
                                      >
                                        {categorie.categorie_appellation}
                                      </option>
                                    ))}
                                </select>
                              ) : (
                                categorieLabel
                              )}
                            </td>
                            <td>
                              {editingBudgetIndex === index ? (
                                <input
                                  type="text"
                                  value={editDescription}
                                  onChange={(e) => setEditDescription(e.target.value)}
                                />
                              ) : (
                                budget.valeur_description
                              )}
                            </td>
                            <td>
                              {editingBudgetIndex === index ? (
                                <input
                                  type="number"
                                  value={editAmount}
                                  onChange={(e) => setEditAmount(e.target.value)}
                                />
                              ) : (
                                budget.valeur_montant
                              )}
                            </td>
                            <td>
                              {editingBudgetIndex === index ? (
                                <>
                                  <button onClick={handleSaveBudgetEdit}>Enregistrer</button>
                                  <button onClick={handleCancelBudgetEdit}>Annuler</button>
                                </>
                              ) : (
                                <>
                                  <button onClick={() => handleEditBudget(index)}>Modifier</button>
                                  <button onClick={() => handleDeleteBudget(index)}>Supprimer</button>
                                </>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <div className="dropdown-buttons">
                  {showSave && (
                    <button onClick={SaveDataBudget}>Enregistrer</button>
                  )}
                  <button onClick={closeDropdown7}>Fermer</button>
                </div>
              </div>
            </div>
            <Modal
              isOpen={isModalOpen}
              onRequestClose={() => setIsModalOpen(false)}
              contentLabel="Team Members"
              style={{
                content: {
                  maxWidth: "600px",
                  margin: "auto",
                  borderRadius: "8px",
                  padding: "20px",
                  marginRight: "25rem",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                  zIndex: "1000", // Ensure it is on top
                },
                overlay: {
                  backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent black
                  backdropFilter: "blur(5px)", // Apply the blur effect
                  zIndex: "999", // Ensure it's below the modal content
                },
              }}
            >
              <button
                className="close-button"
                onClick={() => setIsModalOpen(false)}
                style={{
                  fontSize: "20px",
                  border: "none",
                  background: "none",
                  cursor: "pointer",
                  float: "right",
                }}
              >
                &times;
              </button>
              <h4 style={{ textAlign: "center", marginBottom: "20px" }}>
                Membres de l'équipe
              </h4>

              {/* Button to toggle the add member form */}
              {!showForm && showSave && (
                <div className="dropdown-buttons">
                  <button onClick={() => setShowForm(true)}>
                    Ajouter un membre
                  </button>
                </div>
              )}
              {/* Display team members */}
              {!showForm && (
                <div style={{ marginBottom: "20px" }}>
                  {currentTeamIndex !== null &&
                  teams[currentTeamIndex]?.members?.length > 0 ? (
                    <ul
                      className="team-members-list"
                      style={{ padding: "0", listStyle: "none" }}
                    >
                      {teams[currentTeamIndex].members.map(
                        (member, memberIndex) => (
                          <li
                            key={memberIndex}
                            className="team-member-item"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "10px",
                            }}
                          >
                            <span style={{ fontSize: "16px" }}>
                              {member.nom} {member.prenom} - {member.role}
                            </span>
                            <button
                              onClick={() => handleRemoveMember(memberIndex)}
                              style={{
                                backgroundColor: "transparent",
                                border: "1px solid #ccc",
                                padding: "5px 10px",
                                borderRadius: "4px",
                                cursor: "pointer",
                                fontSize: "14px",
                                color: "#333",
                              }}
                            >
                              Supprimer
                            </button>
                          </li>
                        )
                      )}
                    </ul>
                  ) : (
                    <p style={{ textAlign: "center", color: "#555" }}>
                      Aucun membre ajouté.
                    </p>
                  )}
                </div>
              )}

              {/* Form to add a new member */}
              {showForm && (
                <div className="p-8 bg-white rounded-lg shadow-lg max-w-4xl mx-auto">
                  <h4 className="text-2xl font-semibold text-gray-800 mb-6 text-center">
                    Ajouter un Membre
                  </h4>

                  <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                    {/* Nom */}
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-2">
                        Nom
                      </label>
                      <input
                        type="text"
                        value={newMember.nom}
                        onChange={(e) =>
                          setNewMember({ ...newMember, nom: e.target.value })
                        }
                        placeholder="Nom"
                        className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                      />
                    </div>

                    {/* Prénom */}
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-2">
                        Prénom
                      </label>
                      <input
                        type="text"
                        value={newMember.prenom}
                        onChange={(e) =>
                          setNewMember({
                            ...newMember,
                            prenom: e.target.value,
                          })
                        }
                        placeholder="Prénom"
                        className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                      />
                    </div>

                    {/* Civilité */}
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-2">
                        Civilité
                      </label>
                      <select
                        value={newMember.civility}
                        onChange={(e) =>
                          setNewMember({
                            ...newMember,
                            civility: e.target.value,
                          })
                        }
                        className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                      >
                        <option value="">Sélectionner</option>
                        <option value="Mr">Mr</option>
                        <option value="Mme">Mme</option>
                        <option value="Mlle">Mlle</option>
                      </select>
                    </div>

                    {/* Rôle dans l'équipe */}
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-2">
                        Rôle dans l'équipe
                      </label>
                      <input
                        type="text"
                        value={memberRole}
                        onChange={(e) => setMemberRole(e.target.value)}
                        placeholder="Rôle dans l'équipe"
                        className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                      />
                    </div>

                    {/* Titre */}
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-2">
                        Titre
                      </label>
                      <input
                        type="text"
                        value={newMember.titre}
                        onChange={(e) =>
                          setNewMember({
                            ...newMember,
                            titre: e.target.value,
                          })
                        }
                        placeholder="Titre"
                        className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                      />
                    </div>

                    {/* Email */}
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-2">
                        Email
                      </label>
                      <input
                        type="email"
                        value={memberEmail}
                        onChange={(e) => setMemberEmail(e.target.value)}
                        placeholder="Email"
                        className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                      />
                    </div>

                    {/* Spécialité */}
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-2">
                        Spécialité
                      </label>
                      <input
                        type="text"
                        value={speciality}
                        onChange={(e) => setSpeciality(e.target.value)}
                        placeholder="Spécialité"
                        className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                      />
                    </div>

                    {/* Structure */}
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-2">
                        Structure
                      </label>
                      <input
                        type="text"
                        value={structure}
                        onChange={(e) => setStructure(e.target.value)}
                        placeholder="Structure"
                        className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                      />
                    </div>

                    {/* Contribution */}
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-2">
                        Contribution au projet
                      </label>
                      <input
                        type="text"
                        value={contribution}
                        onChange={(e) => setContribution(e.target.value)}
                        placeholder="Contribution au projet"
                        className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                      />
                    </div>

                    {/* Temps de travail */}
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-2">
                        Temps de travail
                      </label>
                      <input
                        type="text"
                        value={workingTime}
                        onChange={(e) => setWorkingTime(e.target.value)}
                        placeholder="Temps de travail"
                        className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                      />
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="dropdown-buttons">
                    {showSave && (
                      <button
                        onClick={handleAddMember}
                        className="px-6 py-3 bg-blue-600 text-white font-medium rounded-lg shadow hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none"
                      >
                        Enregistrer
                      </button>
                    )}

                    <button
                      onClick={() => setShowForm(false)}
                      className="px-6 py-3 bg-gray-300 text-gray-800 font-medium rounded-lg shadow hover:bg-gray-400 focus:ring-2 focus:ring-gray-300 focus:ring-offset-2 focus:outline-none"
                    >
                      Fermer
                    </button>
                  </div>
                </div>
              )}
            </Modal>
          </>
        )}
        <br />
        {/* Only show "Soumettre" if showSoumettre is true */}
        {showSoumettre && (
          <button
            className="soumettre-button"
            style={{
              marginLeft: "1rem",
              background: "#28a745",
              color: "#fff",
              padding: "8px 16px",
              border: "none",
              borderRadius: "4px",
            }}
            onClick={() => {
              handleSoumettreProject(1);
            }}
          >
            Soumettre
          </button>
        )}
      </div>
    </div>
  );
};

export default Forum_Project;
